<template>
      <v-flex >
          <!-- 
          <v-toolbar flat class="mb-4 text-xs-center">
            <v-btn icon to="/home" >
                <v-icon>arrow_back</v-icon>
              </v-btn>
              <v-toolbar-title class="headline text-xs-center">{{msg}}</v-toolbar-title>
          </v-toolbar>
          -->
          <v-card flat tile class="">
            <v-container  fluid grid-list-lg >
              <v-layout >
                <v-flex justify-center text-xs-left>
                <v-card-text>
                  <div class="mx-auto">
                    
                  </div>
                </v-card-text>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
      </v-flex>
</template>

<script>
export default {
	data () {
		return {
			msg: 'Help'
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/Splash.vue